import { useEffect, useState } from 'react'
import { useModel } from './useModel'
import { AttributeSchema } from '../AttributeSchema'
import { GenerateAttributeFilter, IPageFilterOption, PageParentFilter, PageTemplateFilter, PageTitleFilter } from '../filters'

const DEFAULT_OPTIONS: IPageFilterOption[] = [
  PageTitleFilter,
  PageTemplateFilter,
  PageParentFilter,
]

export const usePageFilterOptions = (withAttributes: boolean = true, baseOptions = DEFAULT_OPTIONS): IPageFilterOption[] => {
  const [options, setOptions] = useState<IPageFilterOption[]>([])
  const Attributes = useModel(AttributeSchema)

  useEffect(() => {
    if (withAttributes) {
      const sub = Attributes.QUERY$().subscribe((attrs) => {
        const opts = [...baseOptions, ...attrs.map(attr => GenerateAttributeFilter(attr))]
        setOptions(opts)
      })
      return () => sub.unsubscribe()
    } else {
      setOptions(baseOptions)
    }
  }, [])

  return options
}
